import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {logPageLoadEvents} from '@ibibo/analytics';
import {useHistory} from 'react-router-dom';
import {setter} from '@ibibo/client-side-storage';

import LoginUI from '../../stories/components/Login/LoginUI';
import UpdatePasswordUI from '../../stories/components/UpdatePassword/UpdatePasswordUI';
import HeaderPartner from '../../stories/components/Header/Header';
import FooterPartner from '../../stories/components/Footer/Footer';
import * as C from '../../stories/components/Onboarding/Common.styles';
import InfoBlock from '../../stories/components/InfoBlock/InfoBlock';
import InfoStrip from '../../stories/components/InfoBlock/InfoStrip';
import Benefits from '../../stories/components/BenefitsBlock/Benefits';
import MySafety from '../../stories/components/MySafety/MySafety';
import PerfectStay from '../../stories/components/PerfectStay/PerfectStay';
import {sendEvarData} from '@ibibo/analytics';

import * as S from '../Onboarding/HomePage.styles';

import * as actions from '../../store/actions/index';
import {login, setAgentData, updateSid} from '../../store/actions/thunk';
import {nextLoader} from '../../store/selectors';

import {mobileSelector} from '../../store/selectors';

import {MOBILE_END_PAGE_URL, VERIFY_PAGE_URL} from '../../constants/index';

import BusinessNeeds from '../../stories/components/BusinessNeeds/BusinessNeeds';
import CashbackBanner from '../../stories/components/CashbackBanner/CashbackBanner';
import WhyMypartner from '../../stories/components/WhyMypartner/WhyMypartner';
import PartnerAdvantage from '../../stories/components/PartnerAdvantage/PartnerAdvantage';
import {Helmet} from 'react-helmet';
const LoginPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const isLoading = useSelector(nextLoader);
  const userMobile = useSelector(mobileSelector);

  const [apiError, setApiError] = useState('');
  const [updatePwdApiError, setUpdatePwdApiError] = useState('');
  const [sendOTPResponse, setSendOTPResponse] = useState(null);
  const [otpVisible, setOtpVisible] = useState(false);
  const [apiDataObject, setApiDataObject] = useState({message: '', data: {account_exists: true}});
  const [forgotPasswordLoader, setForgotPasswordLoader] = useState(false);
  const [updatePwdSuccessMessage, setUpdatePwdSuccessMessage] = useState('');

  const deviceWidth = window.screen.width;
  let blockType = false;
  if (deviceWidth > 1024) {
    blockType = true;
  }

  const successCallback = resp => {
    if (resp.data.status && resp.data.token) {
      dispatch(setAgentData(resp.data.token, successSetAgentData, errorSetAgentData));
    }

    function successUpdateCallback(status) {
      if (resp.mmt_auth) {
        setter('myPartnerAuth', {mmt_auth: resp.mmt_auth});
        setter('experiment', {experiment: resp.experiment});
      }
      if (resp.redirect_url) {
        window.open(resp.redirect_url, '_self');
      } else {
        // window.open('/hotels/', '_self');
      }
    }

    dispatch(updateSid(resp, successUpdateCallback, false));
  };

  const successSetAgentData = () => {
    history.push(VERIFY_PAGE_URL);
  };

  const errorSetAgentData = () => {};

  const sendOTPSuccessCallback = resp => {
    setSendOTPResponse(resp);
    if (resp.data.status && resp.data.token) {
      dispatch(setAgentData(resp.data.token, successSetAgentData, errorSetAgentData));
    }
  };

  const errorCallback = error => {
    setApiError(error.message || 'Error! Please try after sometime.');
    setSendOTPResponse(error);
    // to handle the case where we want to update the pwd(MMT account exists or not)
    setApiDataObject(error);
  };

  let userUrl = window.location.search;
  let newUrl = userUrl.substring(1);
  let docRef = document.referrer;

  const submitDetails = data => {
    let fd = new FormData();
    if (deviceWidth < 1024) {
      fd.append('dt', 'false');
    } else {
      fd.append('dt', 'true');
    }
    fd.append('username', data.username);
    if (sendOTPResponse && sendOTPResponse.data && sendOTPResponse.data.token) {
      fd.append('token', sendOTPResponse.data.token);
    }
    if (data.password) {
      fd.append('password', data.password);
    }
    if (data.mobile_otp) {
      fd.append('mobile_otp', data.mobile_otp);
    }
    if (apiDataObject.data?.account_exists && apiDataObject.data?.token) {
      fd.append('token', apiDataObject.data?.token);
    }
    clearUpdatePasswordMessages();
    // setUpdatePwdSuccessMessage('');
    // setUpdatePwdApiError('');
    fd.append('referrer', userUrl === '' ? docRef : newUrl);
    dispatch(login(fd, successCallback, errorCallback));
  };

  const sendOTPCaller = data => {
    let fd = new FormData();
    if (deviceWidth < 1024) {
      fd.append('dt', 'false');
    } else {
      fd.append('dt', 'true');
    }
    fd.append('username', data.username);
    clearUpdatePasswordMessages();
    setApiError('');
    fd.append('referrer', userUrl === '' ? docRef : newUrl);
    dispatch(login(fd, sendOTPSuccessCallback, errorCallback));
  };

  const resendOTP = () => {
    sendEvarData(
      {
        prop54: 'myPartner|login|OTP|resend',
      },
      true,
    );
    let fd = new FormData();
    fd.append('resend', 'mobile');
    fd.append('is_login', 'true');
    if (sendOTPResponse && sendOTPResponse.data && sendOTPResponse.data.token) {
      fd.append('token', sendOTPResponse.data.token);
    }
    dispatch(actions.resendOTP(fd, 'motp'));
  };

  useEffect(() => {
    logPageLoadEvents('landing:login', {});
  }, []);

  // Update Pwd Case (account_exists: false)
  const updatePassSuccessCallback = (succcessDataOrErrorData: any) => {
    setApiDataObject(succcessDataOrErrorData);
    // to show the updated message on login form for successfull pwd change after he comes back from update pwd page.
    setUpdatePwdSuccessMessage(
      succcessDataOrErrorData.message || 'Error! Please try after sometime.',
    );
    setApiError('');
  };
  const updatePassErrorCallback = data => {
    setUpdatePwdApiError(data.message);
  };
  const setPassword = data => {
    let fd = new FormData();
    fd.append('password', data.password);
    fd.append('confirm_password', data.confirm_pass);
    fd.append('token', apiDataObject.data?.token);
    fd.append('otp', data.mobile_otp);
    dispatch(actions.updatePass(fd, updatePassSuccessCallback, updatePassErrorCallback));
  };
  const resendUpdatePwdOtp = () => {
    setUpdatePwdApiError('');
    dispatch(
      actions.getPassTokenOrResendToken(
        apiDataObject.data?.token,
        getTokenSuccessCallback,
        getTokenErrorCallback,
        'resend',
      ),
    );
  };

  // Forgot Pwd case(Get token and update pwd, account_exists: true)
  const getTokenSuccessCallback = forgotPwdApiTokenData => {
    setForgotPasswordLoader(false);
    setApiDataObject(forgotPwdApiTokenData);
  };
  const getTokenErrorCallback = error => {
    setForgotPasswordLoader(false);
    setApiError(error.message || 'Error! Please try after sometime.');
  };
  const getToken = username => {
    setForgotPasswordLoader(true);
    clearUpdatePasswordMessages();
    dispatch(
      actions.getPassTokenOrResendToken(
        username,
        getTokenSuccessCallback,
        getTokenErrorCallback,
        'forgotPwd',
      ),
    );
  };

  const clearUpdatePasswordMessages = () => {
    setUpdatePwdApiError('');
    setUpdatePwdSuccessMessage('');
  };

  const {message} = apiDataObject;

  const getLoginOrUpdatePwdForm = () => {
    if (
      apiDataObject?.data?.hasOwnProperty('account_exists') &&
      !apiDataObject?.data?.account_exists
    ) {
      return (
        <UpdatePasswordUI
          apiError={updatePwdApiError}
          resendOTP={resendUpdatePwdOtp}
          setPassword={data => setPassword(data)}
          isLoading={isLoading}
          loginApiMessage={message}
          // mobileUser={userMobile}
          //  setLoader={setLoader}
        />
      );
    } else {
      return (
        <LoginUI
          submitDetails={submitDetails}
          sendOTP={sendOTPCaller}
          resendOTP={resendOTP}
          apiError={apiError}
          isLoading={isLoading}
          userMobile={userMobile}
          getToken={getToken}
          forgotPasswordLoader={forgotPasswordLoader}
          updatePwdSuccessMessage={updatePwdSuccessMessage}
        />
      );
    }
  };

  return (
    <>
      <Helmet meta={[{name: 'robots', content: 'noindex, nofollow'}]} />

      <S.HomeWrapper>
        <HeaderPartner userType="login" />
        <S.PageMainWrapper>
          {blockType ? (
            <>
              <InfoBlock />
              <C.SignUpMainWrapper>
                <C.SignUpWhiteOuterWrapper>
                  <C.SignUpWhiteInner>{getLoginOrUpdatePwdForm()}</C.SignUpWhiteInner>
                </C.SignUpWhiteOuterWrapper>
              </C.SignUpMainWrapper>
            </>
          ) : (
            <>
              <C.SignUpMainWrapper>
                <C.SignUpWhiteOuterWrapper>
                  <C.SignUpWhiteInner>{getLoginOrUpdatePwdForm()}</C.SignUpWhiteInner>
                </C.SignUpWhiteOuterWrapper>
              </C.SignUpMainWrapper>
              <InfoBlock />
            </>
          )}
        </S.PageMainWrapper>
        <BusinessNeeds />
        {/* <CashbackBanner /> */}
        <WhyMypartner />
        {/* <InfoStrip />
      <Benefits />
      <Arc /> */}
        <PartnerAdvantage />
        <MySafety />
        <PerfectStay />
        <FooterPartner />
      </S.HomeWrapper>
    </>
  );
};

export default LoginPage;
